import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
});

export const getState = store.getState();
export const AppDispatch = store.dispatch;

export default store;
